import { css } from 'styled-components'

const MOBILE = css`
  /**
  * - prevent jittery focus-switching and "autoscroll" while traversing forms
  * - primarily used for mobile-safari
  */
  input,
  input[type] {
    float: left;
    clear: left;
  }
`

export default MOBILE
